import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  // telegram https://t.me/filmjethub
  // Twitter https://twitter.com/FilmJetHub
  // TikTok https://www.tiktok.com/@filmjethub
  // lindei https://www.linkedin.com/company/filmjethub/
  return (
    <footer className="padding bg-black border-t border-gray">
      <h1 className="cursor-pointer text-red font-bold poppins sm:text-[2rem] text-[1.5rem]">
        FilmJetHub
      </h1>
      <section className="flex  justify-between sm:flex-row flex-col xs:gap-[2rem] gap-[1rem]">
        <div className="flex xs:gap-[1rem] gap-[10px] flex-col xs:mt-[3rem] mt-[10px]">
          <Link
            to={"/about"}
            className="text-white mont  sm:text-[16px] text-[15px] hover:underline"
          >
            About Us
          </Link>

          <Link
            to={"/"}
            className="text-white mont  sm:text-[16px] text-[15px] hover:underline"
          >
            Movies
          </Link>
          <Link
            to={"/tvshows"}
            className="text-white mont  sm:text-[16px] text-[15px] hover:underline"
          >
            Tv Shows
          </Link>
        </div>

        <div className="xs:mt-[3rem] flex xs:gap-[1rem] gap-[10px] flex-col">
          <Link to={"mailto:filmjethub@gmail.com"} className="">
            <p className="text-white sm:text-[17px] text-[15px] mont hover:underline">
              Contact Us for Advertising and Promotions
            </p>
          </Link>

          <Link to={"mailto:filmjethub@gmail.com"} className="">
            <p className="text-white sm:text-[17px] text-[15px] mont hover:underline">
              Report a problem
            </p>
          </Link>

          <p className="text-white sm:text-[17px] text-[15px] mont ">
            You can email us at <strong>filmjethub@gmail.com</strong>
          </p>
        </div>

        <div className="flex items-center sm:gap-[1rem] gap-[15px]">
          <Link to={"https://twitter.com/FilmJetHub"} target="_blank">
            <img
              src="/x.svg"
              alt="x"
              className="sm:w-[40px] w-[20px] sm:h-[40px] h-[20px] hover:mt-[-5px] "
            />
          </Link>
          {/* <Link href={"https://t.me/filmjethub"} target="_blank">
            <img
              src="/telegram.svg"
              alt="x"
              className="sm:w-[40px] w-[20px] sm:h-[40px] h-[20px] hover:mt-[-5px] "
            />
          </Link> */}
          <Link to={" https://www.tiktok.com/@filmjethub"} target="_blank">
            <img
              src="/tiktok.svg"
              alt="x"
              className="sm:w-[40px] w-[20px] sm:h-[40px] h-[20px] hover:mt-[-5px] "
            />
          </Link>
          {/* <Link
            href={" https://whatsapp.com/channel/0029VaaKcKd5Ui2dBTrTIb3z"}
            target="_blank"
          >
            <img
              src="/what.svg"
              alt="x"
              className="sm:w-[40px] w-[20px] sm:h-[40px] h-[20px] hover:mt-[-5px] "
            />
          </Link>
          <Link
            href={" https://www.linkedin.com/company/filmjethub/"}
            target="_blank"
          >
            <img
              src="/linkedin.svg"
              alt="x"
              className="sm:w-[40px] w-[20px] sm:h-[40px] h-[20px] hover:mt-[-5px] "
            />
          </Link> */}
        </div>
      </section>
    </footer>
  );
};

export default Footer;
